var map = {
	"./delivered.png": 6032,
	"./in-apt.png": 5099,
	"./logo.png": 6949,
	"./name.png": 1172,
	"./new.png": 4230,
	"./notfound.png": 2707,
	"./sms.png": 4552,
	"./to-term.png": 5344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;